export enum ELandingHeaderAnimationDelay {
  WHOLE_BLOCK = 0,
  LEFT_BLOCK = 500,
  RIGHT_BLOCK = 1000,
  SUPPORT_BUTTON = 1500,
}

export const LANDING_HEADER_ANIMATION_DURATION = 200
